import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        
        this.events = {
          click: {
              close: 'menuClose'
          }
        };

        this.fadeIn = this.el.animate([
          { opacity: "0" },
          { opacity: "1" },
        ], {
          duration: 200,
          fill: "forwards",
          easing: "ease-in-out",
        });

        this.fadeIn.pause();
      

    }

    menuOpen() {
      document.body.style.overflow = "hidden"
      this.el.style.display = "flex"
      this.fadeIn.playbackRate = 1;
      this.fadeIn.play();
      this.fadeIn.finished.then(() => {
        this.fadeIn.pause();
      })
    }

    menuClose() {
      this.fadeIn.reverse();

      this.fadeIn.finished.then(() => {
        document.body.style.overflow = "auto"
        this.el.style.display = "none"
        this.fadeIn.pause()
      })

    }
}
